export default __webpack_public_path__ + "assets/images/00fb44e613703deddd3059b92b7ce935.svg";